const socialLinks = {
  discord: {
    url: "https://discordapp.com/users/334419819627675648",
    icon: "https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0a69f118df70ad7828d4_icon_clyde_blurple_RGB.svg",
    name: "privatenoobie",
  },
  lemmy: {
    url: "https://sopuli.xyz/u/PrivateNoob",
    icon: "/Lemmy_logo.svg",
    name: "@PrivateNoob@sopuli.xyz",
  },
  vrchat: {
    url: "https://vrchat.com/home/user/usr_2202e075-9a9a-48f1-965c-9e2a79e22fdc",
    icon: "/vrchat.webp",
    name: "PrivateNoob",
  },
  email: {
    url: "mailto:petoth@proton.me",
    icon: "📨",
    name: "petoth@proton.me",
  },
  github: {
    url: "https://github.com/PrivateN00b",
    icon: "/github-mark-white.svg",
    name: "PrivateN00b",
  },
  linkedin: {
    url: "https://www.linkedin.com/in/p%C3%A9ter-t%C3%B3th-5072b7243/",
    icon: "/LinkedIn_icon.svg",
    name: "LinkedIn",
  },
};

export default socialLinks;
